(function(){
  var nav=document.getElementById('fnav');
  if(!nav) return;
  var ticking=false;
  window.addEventListener('scroll',function(){
    if(!ticking){
      ticking=true;
      requestAnimationFrame(function(){
        nav.classList.toggle('scrolled',window.scrollY>80);
        ticking=false;
      });
    }
  },{passive:true});
})();
/* ═══════════════════════════════
   SCROLL ANIMATIONS ENGINE
   Apple-inspired reveal system
   ═══════════════════════════════ */
document.addEventListener("DOMContentLoaded",function(){
  if(!("IntersectionObserver" in window)) return;

  // Note: "anim-ready" class is added via inline <script> in HTML head
  // (before any content renders) to prevent FOUC. No need to add it here.

  /* ── Auto-stagger: find groups of elements and assign delay classes ── */
  function staggerChildren(parentSel, childSel){
    document.querySelectorAll(parentSel).forEach(function(parent){
      var kids = parent.querySelectorAll(childSel);
      kids.forEach(function(kid, i){ if(i<8) kid.classList.add("d"+(i+1)); });
    });
  }

  // Step cards in "How it works"
  staggerChildren(".sg", ".sc");
  // USP feature cards
  staggerChildren(".usp-track", ".uf");
  // Lifestyle image cards
  staggerChildren(".lg", ".lc");
  // FAQ items — excluded from scroll animation (class collision with .fi open/close)
  // Problem points
  staggerChildren(".prob", ".pp");
  // Spec rows (annotated section) — use tight inline delays (10 rows > 8 delay classes)
  document.querySelectorAll(".annotated .specs").forEach(function(specs){
    var rows = specs.querySelectorAll(".sr");
    rows.forEach(function(row, i){ row.style.transitionDelay = (i * 0.06) + "s"; });
  });
  // Pick section stagger
  document.querySelectorAll(".pick").forEach(function(pick){
    var details = pick.querySelector(".pick-details"); if(details) details.classList.add("d2");
  });
  // CTA repeat stagger
  document.querySelectorAll(".cta-repeat").forEach(function(cta){
    var h = cta.querySelector("h2"); if(h) h.classList.add("d1");
    var p = cta.querySelector("p"); if(p) p.classList.add("d2");
    var b = cta.querySelector(".btn"); if(b) b.classList.add("d3");
  });
  // Footer stagger
  document.querySelectorAll(".foot").forEach(function(foot){
    var logo = foot.querySelector(".foot-logo"); if(logo) logo.classList.add("d1");
    var social = foot.querySelector(".foot-social"); if(social) social.classList.add("d2");
    var nav = foot.querySelector(".foot-nav-col"); if(nav) nav.classList.add("d3");
  });

  /* ── Collect ALL animatable elements ── */
  var allTargets = document.querySelectorAll(
    ".fade-in, .slide-up, .slide-left, .slide-right, .scale-in, .blur-in, .lift-in, "+
    ".sc, .uf, .lc, .pp, .deep-img, .isize-badge, .pick-img, "+
    ".cta-repeat h2, .cta-repeat p, .cta-repeat .btn, "+
    ".sr, .foot-logo, .foot-social, .foot-nav-col, .trust-icons-dk, .pick-details"
  );

  /* ── Observer with generous rootMargin for early trigger ── */
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        e.target.classList.add("visible");
        obs.unobserve(e.target);
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: "0px 0px -60px 0px"
  });

  /* ── Respect prefers-reduced-motion: skip observer, show everything ── */
  if(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches){
    allTargets.forEach(function(t){ t.classList.add("visible"); });
    return;
  }

  /* ── Shopify design mode: skip animations for real-time Customizer preview ── */
  var animSel = ".fade-in, .slide-up, .slide-left, .slide-right, .scale-in, .blur-in, .lift-in, "+
    ".sc, .uf, .lc, .pp, .deep-img, .isize-badge, .pick-img, "+
    ".cta-repeat h2, .cta-repeat p, .cta-repeat .btn, "+
    ".sr, .foot-logo, .foot-social, .foot-nav-col, .trust-icons-dk, .pick-details";
  if(window.Shopify && window.Shopify.designMode){
    allTargets.forEach(function(t){ t.classList.add("visible"); });
    document.addEventListener("shopify:section:load", function(){
      document.querySelectorAll(animSel).forEach(function(t){ t.classList.add("visible"); });
    });
    return;
  }

  allTargets.forEach(function(t){ obs.observe(t); });

  /* Safety net: force-reveal any elements IntersectionObserver hasn't reached after 5s.
     Prevents invisible elements on slow/partial scroll or edge-case viewports. */
  setTimeout(function(){
    document.querySelectorAll(animSel).forEach(function(t){
      if(!t.classList.contains("visible")) t.classList.add("visible");
    });
  }, 5000);

  /* ── Parallax-like subtle shift on hero image (desktop only, passive) ── */
  if(window.innerWidth >= 768){
    var heroImg = document.querySelector(".hero .hi img, .hero .hi picture");
    if(heroImg){
      var ticking = false;
      window.addEventListener("scroll", function(){
        if(!ticking){
          ticking = true;
          requestAnimationFrame(function(){
            var scrollY = window.scrollY;
            if(scrollY < 800){
              heroImg.style.transform = "translateY("+(scrollY * 0.12)+"px) scale(1.04)";
              if(heroImg.style.willChange !== "transform") heroImg.style.willChange = "transform";
            } else {
              if(heroImg.style.willChange !== "auto") heroImg.style.willChange = "auto";
            }
            ticking = false;
          });
        }
      }, {passive: true});
      heroImg.style.transition = "transform 0s";
      heroImg.style.willChange = "transform";
    }
  }
});

/* ═══════════════════════════════
   SMOOTH SCROLL FOR CTA BUTTONS
   Respects prefers-reduced-motion
   ═══════════════════════════════ */
var prefersReduced=window.prefersReduced=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;
document.addEventListener("click",function(e){
  var t=e.target.closest("[data-scroll-to]");
  if(!t) return;
  e.preventDefault();
  var sel=t.getAttribute("data-scroll-to");
  var el=document.querySelector(sel);
  if(el){
    // Account for sticky nav height
    var navH=document.getElementById("fnav");
    var offset=navH?navH.offsetHeight+12:60;
    var top=el.getBoundingClientRect().top+window.scrollY-offset;
    window.scrollTo({top:top,behavior:prefersReduced?"instant":"smooth"});
  }
  // Fire analytics event
  var evt=t.getAttribute("data-event");
  if(evt) trackEvent(evt);
});

/* ═══════════════════════════════
   ANALYTICS EVENT TRACKING
   ═══════════════════════════════ */
function trackEvent(name,data){
  // Push to dataLayer (GTM compatible) or custom analytics
  if(window.dataLayer){
    window.dataLayer.push({event:name,eventData:data||{}});
  }
  // Debug logging: append ?debug=true to URL to enable
  if(window.location&&window.location.search.indexOf("debug=true")!==-1){
    if(window.console&&window.console.log) console.log("[Tryggve Event]",name,data||"");
  }
}

// Track funnel: page view
trackEvent("page_view",{page:"landing"});

/* ═══════════════════════════════
   MOBILE STICKY CTA BAR
   ═══════════════════════════════ */
(function(){
  var sticky=document.getElementById("stickyCta");
  if(!sticky) return;
  var hero=document.getElementById("s-hero");
  var signup=document.getElementById("s-signup");
  var ticking=false;

  function update(){
    var scrollY=window.scrollY;
    var heroGone=hero?hero.getBoundingClientRect().bottom<0:scrollY>500;
    var nearSignup=signup?signup.getBoundingClientRect().top<180&&signup.getBoundingClientRect().bottom>0:false;
    if(heroGone&&!nearSignup){sticky.classList.add("show")}else{sticky.classList.remove("show")}
    ticking=false;
  }

  function onScroll(){
    if(!ticking){ticking=true;requestAnimationFrame(update)}
  }

  window.addEventListener("scroll",onScroll,{passive:true});
  window.addEventListener("resize",onScroll,{passive:true});
  update();
})();

/* ═══════════════════════════════
   SIGNUP FORM: KLAVIYO INTEGRATION
   ─ REMOVED ─
   Duplicate handler caused race condition with the inline
   script in tryggve-signup.liquid. Both attached submit
   listeners to #signup-form; the fetch()-based handler here
   destroyed DOM via innerHTML while the XHR handler tried
   to toggle visibility on the same elements. This broke
   Android submissions. The canonical handler now lives
   solely in sections/tryggve-signup.liquid.
   ═══════════════════════════════ */

/* ═══════════════════════════════
   SIGNUP COUNTER: STATISKT BASTAL
   Visar alltid vardet fran sektionsinstallningen (t.ex. +400).
   Vid signup: enbart en pulsanimation, siffran raknas inte upp.
   ═══════════════════════════════ */
(function(){
  var el=document.querySelector(".signup-counter__number");
  if(!el) return;

  window.__incrementSignupCounter=function(){
    el.style.transition="transform .3s ease";
    el.style.transform="scale(1.15)";
    setTimeout(function(){el.style.transform="scale(1)";},300);
  };
})();

/* ═══════════════════════════════
   FAQ: CLICK + KEYBOARD ACCESSIBILITY
   (no inline onclick — all handled here)
   ═══════════════════════════════ */
(function(){
  var questions=document.querySelectorAll(".faq .fi .q");
  questions.forEach(function(q){
    // Make focusable and add ARIA
    if(!q.getAttribute("tabindex")) q.setAttribute("tabindex","0");
    q.setAttribute("role","button");
    var fi=q.parentElement;
    var aWrap=fi.querySelector(".a-wrap");
    var isOpen=fi.classList.contains("open");
    q.setAttribute("aria-expanded",isOpen?"true":"false");
    if(aWrap) aWrap.setAttribute("role","region");

    // Click handler with smooth slide animation
    q.addEventListener("click",function(){
      if(fi.classList.contains("open")){
        // Closing: set explicit height first, then collapse to 0
        aWrap.style.maxHeight=aWrap.scrollHeight+"px";
        requestAnimationFrame(function(){
          aWrap.style.maxHeight="0px";
        });
        fi.classList.remove("open");
      }else{
        // Opening: expand to exact content height, then clear inline style
        fi.classList.add("open");
        aWrap.style.maxHeight=aWrap.scrollHeight+"px";
        aWrap.addEventListener("transitionend",function handler(){
          if(fi.classList.contains("open")) aWrap.style.maxHeight="none";
          aWrap.removeEventListener("transitionend",handler);
        });
      }
      q.setAttribute("aria-expanded",fi.classList.contains("open")?"true":"false");
    });

    // Keyboard support (Enter / Space)
    q.addEventListener("keydown",function(e){
      if(e.key==="Enter"||e.key===" "){
        e.preventDefault();
        q.click();
      }
    });
  });

  // FAQ toggle "show all / show fewer" button (replaces inline onclick)
  var faqToggle=document.querySelector(".faq-toggle");
  if(faqToggle){
    faqToggle.addEventListener("click",function(){
      var fl=faqToggle.previousElementSibling;
      if(!fl) return;
      if(fl.classList.contains("expanded")){
        fl.classList.remove("expanded");
        faqToggle.textContent=faqToggle.dataset.more;
        faqToggle.scrollIntoView({behavior:prefersReduced?"instant":"smooth",block:"center"});
      }else{
        fl.classList.add("expanded");
        faqToggle.textContent=faqToggle.dataset.less;
      }
    });
  }
})();

/* ═══════════════════════════════
   SPEC TOGGLE (moved from inline)
   ═══════════════════════════════ */
(function(){
  var btn=document.getElementById("specBtn");
  if(!btn) return;
  var s=btn.closest(".annotated").querySelector(".specs");
  if(!s) return;
  var arrow=' <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>';

  function open(){
    s.classList.add("spec-open");btn.classList.add("open");
    btn.innerHTML=btn.dataset.hide+arrow;
    btn.setAttribute("aria-expanded","true");
    // Ensure spec rows are visible (observer may not trigger inside overflow:hidden)
    s.querySelectorAll(".sr").forEach(function(row){ row.classList.add("visible"); });
  }
  function close(){
    s.classList.remove("spec-open");btn.classList.remove("open");
    btn.innerHTML=btn.dataset.show+arrow;
    btn.setAttribute("aria-expanded","false");
  }

  // Desktop: start open, mobile: start closed
  if(window.innerWidth>=768){ open(); } else { close(); }

  btn.addEventListener("click",function(){
    if(s.classList.contains("spec-open")){ close(); } else { open(); }
  });
})();

